<template>
  <div>
    <div class="multiselect-wrap--small">
      <multiselect
        ref="myMultiselect"
        v-model="selectedTeams"
        track-by="id"
        label="name"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_DROPDOWN_PLACEHOLDER')"
        :multiple="true"
        selected-label
        :class="{ 'disabled-multiselect': !hasPermission }"
        deselect-label=""
        :max-height="160"
        :options="teams"
        :allow-empty="false"
        @input="updateValue"
        @open="handleOpen"
      />
      <textarea
        v-model="message"
        rows="4"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        :readonly="!hasPermission"
        @input="updateValue"
      />
    </div>
  </div>
</template>

<script>
export default {
  // The value types are dynamic, hence prop validation removed to work with our action schema
  // eslint-disable-next-line vue/require-prop-types
  props: ['teams', 'value', 'hasPermission', 'index'],
  data() {
    return {
      selectedTeams: [],
      message: '',
    };
  },
  mounted() {
    const { team_ids: teamIds } = this.value;
    this.selectedTeams = teamIds;
    this.message = this.value.message;
    document.addEventListener('mousedown', this.handleClickOutside);
    bus.$on('multiselect-open', (source) => {
      if (source !== 'myMultiselect') {
        this.onCloseDropdown();
      }
    });
    bus.$on('multi-open', (sourceIndex) => {
      if (sourceIndex !== this.index) {
        this.onCloseDropdown();
      }
    });
  },
  beforeDestroy() {
    bus.$off('multiselect-open');
    bus.$off('multi-open') ;
  },
  methods: {
    updateValue() {
      this.$emit('input', {
        team_ids: this.selectedTeams.map(team => team.id),
        message: this.message,
      });
    },
    handleOpen() {
      bus.$emit('multiselect-open', 'myMultiselect');
      this.$emit('multiOpen');
      bus.$emit('multi-open', this.index);
      this.$emit('multiSelectOpen', this.index);
    },
    handleClickOutside(event) {
      if (this.$refs.myMultiselect) {
        // Access the underlying DOM element
        const dropdownElement = this.$refs.myMultiselect.$el;
        if (!dropdownElement.contains(event.target)) {
          this.onCloseDropdown();
        }
      }
    },
    onCloseDropdown() {
      // Access the multiselect component using its ref and call deactivate method
      if (this.$refs.myMultiselect) {
        this.$refs.myMultiselect.deactivate();
      }
    },
  },

};
</script>

<style scoped>
.multiselect {
  margin: var(--space-smaller) var(--space-zero);
}
textarea {
  margin-bottom: var(--space-zero);
}

.disabled-multiselect {
    pointer-events: none;
    opacity: 0.5;
}
</style>
